<!-- <app-faq-title></app-faq-title> -->

<div class="faq-container">
  <div class="row child-container-one">
    <section class="col-xl-8 col-lg-8 col-12 leftSection" *ngIf="faq">
      <div class="col" *ngIf="baseSiteId == 'vsh'">Find fast answers to common questions about how to use VaccineShop.com.</div>
      <div class="col" *ngIf="baseSiteId == 'vax'">Find fast answers to common questions about how to use VaxServe.com.</div>
      <mat-accordion #accordions [multi]="true" *ngFor="let f of faq; let i = index;">
        <mat-expansion-panel #outerPanel hideToggle [ngClass]="panelOpenState? '' : 'border-bottom'"
          (opened)="panelOpenState = true" (closed)="panelOpenState = false" class="outerPanel">
          <mat-expansion-panel-header class="mt-2 mb-2" [ngClass]="i == 0 ? 'mt-4' : 'mt-2'">
            <mat-panel-title class="categoryName" (click)="$event.stopPropagation();">
              {{ f.item }}
            </mat-panel-title>
            <p class="align-middle alignAllText">
              <span (click)="showOnlyQuestions(i)">+/-</span>
              <span class="ml-1" (click)="toggle(i)">All</span>
            </p>
          </mat-expansion-panel-header>
          <mat-expansion-panel class="innerPanel border-bottom" #panel (opened)="panelOpenState = true"
            (closed)="panelOpenState = false" *ngFor="let q of f.questions; let j=index;" [expanded]="q.open"
            hideToggle>
            <mat-expansion-panel-header class="p-0" [ngClass]="j==0 ? 'border-top' : '' ">
              <mat-panel-title class="question" (click)="$event.stopPropagation();">
                {{ q.question }}
              </mat-panel-title>
              <img src="../../../assets/icons/{{baseSiteId}}/plus-green.png" *ngIf="!panel.expanded"
                class="openPanelIcon">
              <img src="../../../assets/icons/{{baseSiteId}}/minus-green.png" *ngIf="panel.expanded"
                class="closePanelIcon">
            </mat-expansion-panel-header>
            <p class="answer">
              <app-accordian-answers [answers]="q.answer"></app-accordian-answers>
            </p>
          </mat-expansion-panel>
        </mat-expansion-panel>
      </mat-accordion>
    </section>
    <aside class="col-xl-4 col-lg-4 col-12 medium pl-0 right-navigation">
      <div class="col-md-6 col-sm-6 col-lg-12 col-xl-12 quick_link ml-3 mt-3">
        <h3>Quick links</h3>
        <div class="mt-4">
          <div class="content">
            <div class=""><a (click)="goToPatientEducation()" title="" target="">Vaccination solutions &amp; patient
                education</a>
              <p>Discover Immunization planning resources, as well as our library of downloadable posters, brochures,
                social posts and more.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col col-md-6 col-sm-6 col-lg-12 col-xl-12 content needAssistance">
        <div class="ml-3 mt-3">
          <span class="Need-assistance">Need assistance?</span>
          <div class="Contact-support">
            <span>Contact our support center</span>
            <span>Monday - Friday</span>
            <span class="support-time">8:30 AM - 5:00 PM (ET)</span>
          </div>
          <div class="Contact-details">
            <span>
              <img src="../../../assets/icons/{{baseSiteId}}/phone.svg" alt="phone">
            </span>
            <span *ngIf="baseSiteId == 'vsh'">1-800-VACCINE (1-800-822-2463)</span>
            <span *ngIf="baseSiteId == 'vax'">1-800-752-9338</span>
          </div>
          <div class="Contact-details">
            <span>
              <img src="../../../assets/icons/{{baseSiteId}}/mail-new.svg" alt="email">
            </span>
            <span *ngIf="baseSiteId == 'vsh'">
              <a href="mailto:vaccineshoppe.svc@sanofi.com">{{vshEmail}}</a>
            </span>
            <span *ngIf="baseSiteId == 'vax'">
              <a href="mailto:VaxServe@vaxserve.com">{{vaxEmail}}</a>
            </span>
          </div>
        </div>
      </div>
    </aside>

    <!-- <mat-accordion #accordions *ngFor="let f of faq">
      <mat-expansion-panel hideToggle [expanded]= "true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ f.item }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p>This is the primary content of the panel.</p>
      </mat-expansion-panel>
      <mat-expansion-panel (opened)="panelOpenState = true"
                           (closed)="panelOpenState = false" *ngFor="let q of f.questions">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ q.question }}
          </mat-panel-title>
          <mat-panel-description>
            Currently I am {{panelOpenState ? 'open' : 'closed'}}
          </mat-panel-description>
        </mat-expansion-panel-header>
        <p><app-accordian-answers
          [answers]="q.answer"
        ></app-accordian-answers></p>
      </mat-expansion-panel>
    </mat-accordion>  -->

    <!-- <ngb-accordion class="parent">
      <ngb-panel *ngFor="let f of faq">{{f | json}}
        <ng-template ngbPanelHeader let-opened="opened">
          <div
            class="
              d-flex
              align-items-center
              justify-content-between
              faq-panel-header
            "
          >
            <h3 class="m-0">{{ f.item }}</h3>
            <button ngbPanelToggle class="btn btn-link p-0">
              <span *ngIf="!opened" class="plus-icon blue"></span
              ><span *ngIf="opened" class="minus-icon blue"></span>
            </button>
          </div>
        </ng-template>
        <ng-template ngbPanelContent>
          <div class="expand-all-sec all">
            <span class="expand-toggle" (click)="toggleAll()">All</span>
          </div>
          <ngb-accordion #a="ngbAccordion" class="child">
            <ngb-panel *ngFor="let q of f.questions">
              <ng-template ngbPanelHeader let-opened="opened">
                <div
                  class="
                    d-flex
                    align-items-center
                    justify-content-between
                    sub-faq-panel-header
                    panel-title
                  "
                >
                  <h5 class="m-0 expand-details">{{ q.question }}</h5>
                  <button ngbPanelToggle class="btn btn-link p-0 sub-icon">
                    <span *ngIf="!opened" class="plus-icon blue"></span
                    ><span *ngIf="opened" class="minus-icon blue"></span>
                  </button>
                </div>
              </ng-template>
              <ng-template ngbPanelContent class="pl-5 pt-2 pb-2">
                <app-accordian-answers
                  [answers]="q.answer"
                ></app-accordian-answers>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>
        </ng-template>
      </ngb-panel>
    </ngb-accordion> -->
  </div>
</div>